import React from 'react'

export const RightSVG = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 50 52" fill="none" xmlns="https://www.w3.org/2000/svg">
            <path d="M50 26L0.5 51.9808L0.5 0.0192375L50 26Z" fill="#233A8B"/>
        </svg>
    );
}
